import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CustomEmailAction from './CustomEmailAction';

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/action" element={<CustomEmailAction />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;